import { Typography, TypographyProps } from '@material-ui/core';
import { clsx } from '@components/Provider';
import { ElementType } from 'react';

interface ExtendedTypographyProps extends TypographyProps {
  component?: ElementType;
}

interface Props extends ExtendedTypographyProps {
  as?: ElementType;
  fontWeight?: '100' | '300' | '500' | '700' | '900' | 'bold' | 'normal';
  gutterBottoms?: number;
}

const CustomizedTypography: React.FC<Props> = (props) => {
  const { fontWeight, gutterBottoms, color, as, component, ...rest } = props;
  let styled = {};
  styled = fontWeight ? { fontWeight: fontWeight } : styled;
  styled = gutterBottoms ? { ...styled, marginBottom: gutterBottoms } : styled;

  return (
    <Typography
      {...rest}
      component={as ? as : (component as ElementType)}
      className={clsx('customized-typography', props.className, props.variant)}
      style={{ ...styled, ...rest.style }}
      color={color ?? 'textPrimary'}
      variantMapping={{ 'caption': 'p' }}
    >
      {props.children}
    </Typography>
  );
};

export default CustomizedTypography;
